import { Outlet, useLocation } from "react-router-dom";
import {
  GscDateRangeControls,
  type GscDateRangeControlsVariant,
} from "@/components/gsc/GscDateRangeControls";
import {
  getGscLayoutVariant,
  useGscDataUpdatedAt,
} from "@/hooks/useGscData";

export default function GscLayout() {
  const { pathname } = useLocation();
  const variant: GscDateRangeControlsVariant = getGscLayoutVariant(pathname);
  const dataUpdatedAt = useGscDataUpdatedAt();

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="-mx-4 -mt-4 border-b border-border bg-card px-4 py-3 md:-mx-8 md:-mt-8 md:px-8">
        <GscDateRangeControls
          variant={variant}
          dataUpdatedAt={dataUpdatedAt}
          embedded
        />
      </div>

      <div className="flex flex-col gap-6 pt-6">
        <Outlet />
      </div>
    </div>
  );
}
